import React from "react";
import { bool, func, shape, string } from "prop-types";
import { Box, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VideoPlayer from "./details/VideoPlayer";

const VideoDialog = ({ modalOpen, toggleModal, video }) => (
  <Dialog fullWidth maxWidth="md" open={modalOpen} onClose={toggleModal}>
    <DialogActions classes={{}}>
      <Button variant="text" onClick={toggleModal} startIcon={<CloseIcon />}>
        Close
      </Button>
    </DialogActions>
    <DialogContent>
      {video && (video.id || video.youtube_id) && (
        <Box style={{ minHeight: "550px" }}>
          <VideoPlayer video={video} isFeatured={true} />
        </Box>
      )}
    </DialogContent>
  </Dialog>
);

VideoDialog.propTypes = {
  modalOpen: bool.isRequired,
  toggleModal: func.isRequired,
  video: shape({
    id: string,
    youtube_id: string,
  }),
};

export default VideoDialog;
